module.exports = "/assets/data/30f7be1b13e1aeeabeb4d1ed5492d0fa-PL7.data.json";